<template>
<div class="mb-3">
    <form-question-images
        :id="id_computed"
        :required="true"
        :request_form="request_form"
        @update-value="updateValue"
    />
</div>
</template>

<script>
import FormQuestionImages from '../questions/FormQuestionImage.vue';

export default {
    name: 'FormSubmittableImages',
    components: {
        FormQuestionImages,
    },
    props: {
        id: {
            type: String,
            required: false,
        },
        question: {
            type: Object,
            required: false,
        },
        request_form: {
            type: Object,
            required: false,
        },
    },
    computed: {
        id_computed() {
            return this.id ?? 'images';
        }
    },
    methods: {
        updateValue(id, value) {
            this.$emit('update-value', id, value);
        },
    }
}
</script>
